import App from './App.svelte';

// Sentry.init({ dsn: 'https://052cc5f755a647cf894dc62a8e5fb132@sentry.io/1757176' });

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;